import { Model } from '@/models/Model';
import { UseInfiniteServiceResult } from '@/data/hook/useInfiniteService';

type MergeResultsFn<T> = (...results: T[][]) => T[];

export const mergeQueries = <T extends Model>(
  queries: UseInfiniteServiceResult<Model>[],
  mergeResultsFn: MergeResultsFn<T>,
) => {
  const results = queries.map(query => query.results) as T[][];
  const isInitialLoading = queries.some(query => query.isInitialLoading);
  const isFetching = queries.some(query => query.isFetching);
  const isFetchingNextPage = queries.some(query => query.isFetchingNextPage);
  const hasNextPage = queries.some(query => query.hasNextPage);
  const fetchNextPage = () => {
    if (isFetching) return;
    queries.forEach(query => query.fetchNextPage?.());
  };
  const invalidate = async () => {
    await Promise.all(queries.map(query => query.invalidate()));
  };
  return {
    results: mergeResultsFn(...results),
    isInitialLoading,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    invalidate,
  } as UseInfiniteServiceResult<T>;
};
